import React from 'react';

import {
	ExtensionMode,
	HubExtensionsWrapper,
	type HubExtensionsWrapperProps,
	useProductDependencies,
} from '@atlassian/company-hub-common';

import type { CarouselExtensionProps, CarouselParameters } from '../../../types';
import { CarouselContentV2 } from '../../carousel-content';

export const CarouselRenderer = ({
	extensionNode,
	contentId,
}: HubExtensionsWrapperProps<CarouselParameters>): React.JSX.Element => {
	const { parameters, localId = '' } = extensionNode || {};
	const { isCompanyHub } = useProductDependencies();

	return (
		<HubExtensionsWrapper<CarouselParameters>
			extensionNode={extensionNode}
			contentId={contentId}
			mode={ExtensionMode.RENDERER}
			showNoDataState={!parameters}
			packageName="carousel-extension"
		>
			{parameters && (
				<CarouselContentV2
					extensionLocalId={localId}
					parameters={parameters}
					isInViewMode
					contentId={contentId}
					isCompanyHub={isCompanyHub}
				/>
			)}
		</HubExtensionsWrapper>
	);
};

export const Carousel = ({
	propsProvider: PropsProvider,
	extensionNode,
	contentId,
}: CarouselExtensionProps): React.JSX.Element => (
	<PropsProvider mode={ExtensionMode.RENDERER} extensionNode={extensionNode} contentId={contentId}>
		<CarouselRenderer extensionNode={extensionNode} contentId={contentId} />
	</PropsProvider>
);
